/**
 * Mock Email Service
 *
 * In-memory mock that mirrors the real emailService API.
 * Used when VITE_ENABLE_MOCK_DATA=true.
 */

import { mockEmails } from '../data/mockData';

let emails = JSON.parse(JSON.stringify(mockEmails));
let nextId = 100;

const delay = (ms = 200) => new Promise(r => setTimeout(r, ms));

export const getEmails = async (params = {}) => {
  await delay();
  const { search = '', verificationStatus = '', page = 1, limit = 10 } = params;

  let filtered = emails;
  if (search) {
    const term = search.toLowerCase();
    filtered = filtered.filter(e =>
      e.email.toLowerCase().includes(term) ||
      (e.name && e.name.toLowerCase().includes(term))
    );
  }
  if (verificationStatus) {
    filtered = filtered.filter(e => e.verificationStatus === verificationStatus);
  }

  const total = filtered.length;
  const totalPages = Math.ceil(total / limit) || 1;
  const start = (page - 1) * limit;
  const data = filtered.slice(start, start + limit);

  return { data, pagination: { page, limit, total, totalPages } };
};

export const getEmailById = async (emailId) => {
  await delay();
  const email = emails.find(e => e.id === emailId);
  if (!email) throw new Error('Email not found');
  return { ...email };
};

export const createEmail = async (emailData) => {
  await delay(300);
  const newEmail = {
    id: nextId++,
    email: emailData.email,
    name: emailData.name || '',
    verificationStatus: 'active',
    dateAdded: new Date().toISOString().split('T')[0],
    lastAttempt: new Date().toISOString().split('T')[0]
  };
  emails.push(newEmail);
  return { data: newEmail };
};

export const updateEmail = async (emailId, emailData) => {
  await delay(300);
  const email = emails.find(e => e.id === emailId);
  if (!email) throw new Error('Email not found');
  if (emailData.name !== undefined) email.name = emailData.name;
  return { data: { id: emailId, name: email.name } };
};

export const deleteEmail = async (emailId) => {
  await delay(300);
  emails = emails.filter(e => e.id !== emailId);
  return { success: true };
};

// resendVerification removed — SES verification flow no longer used (PSE-299)
